import "whatwg-fetch";
import React from "react";
import Alert from "react-bootstrap/es/Alert";
import Select from "react-select";
import "react-select/dist/react-select.css";
import { SkyLightStateless } from "react-skylight";
import { RaisedButton, TextField } from "material-ui";
import { Constants } from "../../../../constants";
import RedirectIfNotLogged from "../../../menu/redirect-if-not-logged";
import { styles } from "../../../menu/styles";
import Header from "../../../header";
import * as validator from "../../../../general/validators/validator";
import request from "../../../../config/axios-config";
import { connect } from "react-redux";
import * as ErrorAction from "../../../../redux/action/error-action";
import ImageUploader from "react-images-upload";
import { CircularProgress } from "material-ui";
import {
  HorizontalContainer,
  HorizontalMargin,
  VerticalContainer
} from "../../../Common";
import { uploadSignature } from "../../../../services/user-service";

class AddUserModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      modalIsOpen: true,
      departmentOptions: [],
      roleOptions: [],
      positionOptions: [],
      isActive: true,
      uploadingSignature: false,
      error: {
        email: null,
        firstName: null,
        middleName: null,
        lastName: null,
        passwordFirst: null,
        passwordSecond: null
      }
    };
  }

  closeModal = () => {
    this.setState({
      modalIsOpen: false,
      alreadyExists: false,
      name: this.props.initialName
    });
    this.props.onCancel();
  };

  componentWillUnmount() {
    this.props.hideError();
  }

  componentDidMount() {
    let departmentOps = this.props.departments.map((t, i) => {
      return { value: t.id, label: t.name };
    });
    let roleOps = this.props.roles.map((t, i) => {
      return { value: t.id, label: t.name };
    });

    let positionOps = this.props.positions.map((t, i) => {
      return { value: t.id, label: t.name };
    });
    this.setState({
      modalIsOpen: this.state.modalIsOpen,
      alreadyExists: false,
      departmentOptions: departmentOps,
      roleOptions: roleOps,
      positionOptions: positionOps,

      firstName: this.props.firstName,
      middleName: this.props.middleName,
      lastName: this.props.lastName,
      email: this.props.email,
      selectedPosition: this.props.selectedPosition,
      selectedRole: this.props.selectedRole,
      selectedDepartment: this.props.selectedDepartment,
      isActive: this.props.isActive,
      editTitle: this.props.editTitle,
      canSeeAllReports: this.props.canSeeAllReports,
      canEditAcquisitionsReports: this.props.canEditAcquisitionsReports,
      canEditAccountingReports: this.props.canEditAccountingReports,
      canEditReceptionReports: this.props.canEditReceptionReports,
      canSeeContracts: this.props.canSeeContracts,
      canSeeApprovedPapers: this.props.canSeeApprovedPapers,
      canSeeAllPapers: this.props.canSeeAllPapers,
      canSetPaperAsPrinted: this.props.canSetPaperAsPrinted,
      canSeePapersExcelReport: this.props.canSeePapersExcelReport,
      signatureLink: this.props.signatureLink
    });
  }

  onSave = () => {
    if (!this.validateInput()) {
      return;
    }

    const userJson = JSON.stringify({
      id: this.props.id || -1, // send -1 because backend expect a value ...
      firstName: this.state.firstName.trim(),
      middleName: this.state.middleName,
      lastName: this.state.lastName.trim(),
      email: this.state.email.trim(),
      password: this.state.passwordFirst
        ? this.state.passwordFirst.trim()
        : null,
      isActive: this.state.isActive,
      department: this.state.selectedDepartment,
      position: this.state.selectedPosition,
      role: this.state.selectedRole,
      isEdit: this.props.isEdit,
      canSeeAllReports: this.state.canSeeAllReports,
      canEditAcquisitionsReports: this.state.canEditAcquisitionsReports,
      canEditAccountingReports: this.state.canEditAccountingReports,
      canEditReceptionReports: this.state.canEditReceptionReports,
      canSeeContracts: this.state.canSeeContracts,
      canSeeApprovedPapers: this.state.canSeeApprovedPapers,
      canSeeAllPapers: this.state.canSeeAllPapers,
      canSetPaperAsPrinted: this.state.canSetPaperAsPrinted || false,
      canSeePapersExcelReport: this.state.canSeePapersExcelReport
    });
    request({
      method: "POST",
      url: Constants.SERVER_ENDPOINT + "/user/add",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json"
      },
      data: userJson
    })
      .then(json => {
        this.closeModal();
      })
      .catch(err => {
        //TODO erorr handling
        this.props.showError("Adaugarea a esuat! Va rog reincercati");
        this.setState({
          modalIsOpen: true,
          alreadyExists: true
        });
      });
  };
  onDepartmentChange = val => {
    this.setState({
      selectedDepartment: val
    });
  };

  onLastNameChange = e => {
    this.setState({
      lastName: e.target.value
    });
  };

  onMiddleNameChange = e => {
    this.setState({
      middleName: e.target.value
    });
  };

  onFirstNameChange = e => {
    this.setState({
      firstName: e.target.value
    });
  };

  onEmailChange = e => {
    this.setState({
      email: e.target.value
    });
  };

  onPasswordFirstChange = e => {
    this.setState({
      passwordFirst: e.target.value
    });
  };

  onPasswordSecondChange = e => {
    this.setState({
      passwordSecond: e.target.value
    });
  };

  handleActiveChange = () => {
    let newState = this.state;
    this.setState({
      isActive: !newState.isActive
    });
  };

  validateInput = () => {
    let error = {};
    let foundError = false;
    if (validator.isEmpty(this.state.email)) {
      error.email = "Lipseste emailul!";
      foundError = true;
    }
    if (
      !validator.isEmpty(this.state.email) &&
      !validator.isValidEmail(this.state.email)
    ) {
      error.email = "Emailul nu are formatul correct!";
      foundError = true;
    }
    if (validator.isEmpty(this.state.firstName)) {
      error.firstName = "Lipseste prenumele!";
      foundError = true;
    }
    if (validator.isEmpty(this.state.lastName)) {
      error.lastName = "Lipseste numele";
      foundError = true;
    }
    if (!this.props.isEdit && validator.isEmpty(this.state.passwordFirst)) {
      error.passwordFirst = "Lipseste parola";
      foundError = true;
    }
    if (!this.props.isEdit && validator.isEmpty(this.state.passwordSecond)) {
      error.passwordSecond = "Lipseste parola";
      foundError = true;
    }
    if (
      !validator.isEmpty(this.state.passwordFirst) &&
      !validator.isEmpty(this.state.passwordSecond) &&
      this.state.passwordFirst !== this.state.passwordSecond
    ) {
      error.passwordSecond = "Ati gresit parola";
      foundError = true;
    }
    if (
      !foundError &&
      this.state.passwordFirst &&
      this.state.passwordFirst.length < Constants.MIN_PASSWORD_LENGTH
    ) {
      error.passwordFirst = "Parola e prea scurta. Minim 6 caractere";
      error.passwordSecond = "Parola e prea scurta. Minim 6 caractere";
      foundError = true;
    }

    this.setState({
      error: error
    });
    return !foundError;
  };

  render() {
    return (
      <div>
        <RedirectIfNotLogged />
        <SkyLightStateless
          isVisible={this.state.modalIsOpen}
          dialogStyles={styles.defaultDialogStyles}
          onCloseClicked={this.closeModal}
          onOverlayClicked={this.closeModal}
          title={<Header title={this.props.title} />}
        >
          <div>
            {this.state.alreadyExists ? (
              <Alert className="alert alert-danger">
                Department already exists! Try another name
              </Alert>
            ) : (
              ""
            )}

            <div className="ds-form-table"><table className="table table-hover">
              <tbody>
                <tr>
                  <td>Email</td>
                  <td>
                    <TextField
                      hintText={"Email"}
                      value={this.state.email}
                      errorText={this.state.error.email}
                      onChange={this.onEmailChange}
                    />
                  </td>
                </tr>

                <tr>
                  <td>Prenume</td>
                  <td>
                    <TextField
                      hintText={"Prenumele"}
                      value={this.state.firstName}
                      errorText={this.state.error.firstName}
                      onChange={this.onFirstNameChange}
                    />
                  </td>
                </tr>

                <tr>
                  <td>Nume Mijlociu</td>
                  <td>
                    <TextField
                      hintText={"Nume mijlociu"}
                      value={this.state.middleName}
                      errorText={this.state.error.middleName}
                      onChange={this.onMiddleNameChange}
                    />
                  </td>
                </tr>

                <tr>
                  <td>Nume</td>
                  <td>
                    <TextField
                      hintText={"Nume"}
                      value={this.state.lastName}
                      errorText={this.state.error.lastName}
                      onChange={this.onLastNameChange}
                    />
                  </td>
                </tr>

                <tr>
                  <td>Parola</td>
                  <td>
                    <TextField
                      type={"password"}
                      hintText={"Parola"}
                      value={this.state.passwordFirst}
                      errorText={this.state.error.passwordFirst}
                      onChange={this.onPasswordFirstChange}
                    />
                  </td>
                </tr>

                <tr>
                  <td>Repeta parola</td>
                  <td>
                    <TextField
                      type={"password"}
                      hintText={"Repeta parola"}
                      value={this.state.passwordSecond}
                      errorText={this.state.error.passwordSecond}
                      onChange={this.onPasswordSecondChange}
                    />
                  </td>
                </tr>

                <tr>
                  <td>Compartiment</td>
                  <td>
                    <Select
                      ref="stateSelect"
                      autoFocus
                      options={this.state.departmentOptions}
                      simpleValue
                      clearable={true}
                      name="selected-state"
                      disabled={false}
                      value={this.state.selectedDepartment}
                      onChange={this.onDepartmentChange}
                      searchable={true}
                    />
                  </td>
                </tr>

                <tr>
                  <td>Activ</td>
                  <td>
                    <input
                      type="checkbox"
                      checked={this.state.isActive}
                      onChange={this.handleActiveChange}
                    />
                  </td>
                </tr>

                <tr>
                  <td />
                  <td />
                </tr>
                <tr>
                  <td>Poate vedea rapoarte?</td>
                  <td>
                    <input
                      type="checkbox"
                      checked={this.state.canSeeAllReports}
                      onChange={() => {
                        let newState = this.state;
                        this.setState({
                          canSeeAllReports: !newState.canSeeAllReports
                        });
                      }}
                    />
                  </td>
                </tr>

                <tr>
                  <td>Poate edita articole dep. Achizitii??</td>
                  <td>
                    <input
                      type="checkbox"
                      checked={this.state.canEditAcquisitionsReports}
                      onChange={() => {
                        let newState = this.state;
                        this.setState({
                          canEditAcquisitionsReports: !newState.canEditAcquisitionsReports
                        });
                      }}
                    />
                  </td>
                </tr>

                <tr>
                  <td>Poate edita articole dep. Contabilitate?</td>
                  <td>
                    <input
                      type="checkbox"
                      checked={this.state.canEditAccountingReports}
                      onChange={() => {
                        let newState = this.state;
                        this.setState({
                          canEditAccountingReports: !newState.canEditAccountingReports
                        });
                      }}
                    />
                  </td>
                </tr>

                <tr>
                  <td>Poate edita articole dep. Magazie?</td>
                  <td>
                    <input
                      type="checkbox"
                      checked={this.state.canEditReceptionReports}
                      onChange={() => {
                        let newState = this.state;
                        this.setState({
                          canEditReceptionReports: !newState.canEditReceptionReports
                        });
                      }}
                    />
                  </td>
                </tr>

                <tr>
                  <td>Poate vedea/edita contracte?</td>
                  <td>
                    <input
                      type="checkbox"
                      checked={this.state.canSeeContracts}
                      onChange={() => {
                        let newState = this.state;
                        this.setState({
                          canSeeContracts: !newState.canSeeContracts
                        });
                      }}
                    />
                  </td>
                </tr>
                <tr>
                  <td>Poate vedea referatele aprobate?</td>
                  <td>
                    <input
                      type="checkbox"
                      checked={this.state.canSeeApprovedPapers}
                      onChange={() => {
                        let newState = this.state;
                        this.setState({
                          canSeeApprovedPapers: !newState.canSeeApprovedPapers
                        });
                      }}
                    />
                  </td>
                </tr>
                <tr>
                  <td>Poate vedea toate referatele?</td>
                  <td>
                    <input
                      type="checkbox"
                      checked={this.state.canSeeAllPapers}
                      onChange={() => {
                        let newState = this.state;
                        this.setState({
                          canSeeAllPapers: !newState.canSeeAllPapers
                        });
                      }}
                    />
                  </td>
                </tr>
                
                <tr>
                  <td>Poate seta referatele ca si printate?</td>
                  <td>
                    <input
                      type="checkbox"
                      checked={this.state.canSetPaperAsPrinted}
                      onChange={() => {
                        let newState = this.state;
                        this.setState({
                          canSetPaperAsPrinted: !newState.canSetPaperAsPrinted
                        });
                      }}
                    />
                  </td>
                </tr>

                <tr>
                  <td>Raport referate?</td>
                  <td>
                    <input
                      type="checkbox"
                      checked={this.state.canSeePapersExcelReport}
                      onChange={() => {
                        let newState = this.state;
                        this.setState({
                          canSeePapersExcelReport: !newState.canSeePapersExcelReport
                        });
                      }}
                    />
                  </td>
                </tr>

                {this.props.id && (
                  <tr>
                    <td>Seteaza semnatura</td>
                    <td>
                      <HorizontalContainer>
                        <ImageUploader
                          withIcon={true}
                          buttonText="Adauga semnatura"
                          onChange={async (pictureFiles, pictureDataURLs) => {
                            this.setState({ uploadingSignature: true });

                            try {
                              const result = await uploadSignature(
                                pictureFiles[pictureFiles.length - 1],
                                this.props.id
                              );
                              this.setState({
                                uploadingSignature: false,
                                signatureLink: result.data
                              });
                            } catch (e) {
                              this.setState({ uploadingSignature: false });
                            }
                          }}
                          imgExtension={[".jpg", ".png"]}
                          label={
                            "Dimensiune maxima 10MB. Se recomanda rezolutie 400x200 px"
                          }
                          maxFileSize={10242880}
                        />

                        {this.state.signatureLink && (
                          <VerticalContainer
                            style={{ justifyContent: "center" }}
                          >
                            <img
                              style={{
                                width: 200,
                                height: 100,
                                objectFit: "contain"
                              }}
                              src={this.state.signatureLink}
                            />
                          </VerticalContainer>
                        )}
                      </HorizontalContainer>
                      {this.state.uploadingSignature && (
                        <HorizontalContainer
                          style={{ justifyContent: "center" }}
                        >
                          <CircularProgress />
                        </HorizontalContainer>
                      )}
                    </td>
                  </tr>
                )}

                <tr>
                  <td>
                    <RaisedButton
                      secondary
                      label={"Renunta"}
                      onClick={() => this.closeModal()}
                    />
                  </td>
                  <td>
                    <RaisedButton
                      primary
                      label={"Salveaza"}
                      onClick={() => this.onSave()}
                    />
                  </td>
                </tr>
              </tbody>
            </table></div>
          </div>
        </SkyLightStateless>
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {};
}

function mapDispatchToProps(dispatch) {
  return {
    showError: text => dispatch(ErrorAction.showError(text)),
    hideError: () => dispatch(ErrorAction.hideError())
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddUserModal);
